const opt = (arr) => arr.map((v) => ({ value: v, label: v }));

export const INN_STATUS = ["Idea", "Researching", "Validating", "Planned", "On roadmap", "Deferred", "Rejected", "Delivered"];
export const INN_HORIZON = ["Post-launch", "6–12 months", "12–24 months", "Long term"];
export const INN_PRIORITY = ["Low", "Medium", "High", "Critical"];
export const INN_OWNERS = ["Steven", "Richard", "Both", "External"];

export const asOpts = opt;

export const INN_REVIEW_OUTCOMES = [
  "Reviewed — continue unchanged",
  "Reviewed — more research required",
  "Reviewed — move toward roadmap",
  "Reviewed — defer",
  "Not reviewed — scheduling conflict",
  "Not reviewed — awaiting information",
  "Other",
];

export const INN_ROADMAP_STATUSES = ["Planned", "On roadmap"];
export const innHorizonAccent = (h) => ({ "Post-launch": "#06B6D4", "6–12 months": "#1D4ED8", "12–24 months": "#7C3AED", "Long term": "#5A6B8C" }[h] || "#5A6B8C");
export const innHorizonBlurb = (h) => ({ "Post-launch": "Right after launch", "6–12 months": "Within a year", "12–24 months": "1–2 years out", "Long term": "Beyond 2 years" }[h] || "");

export const innPriorityBadge = (p) => ({ Low: "info", Medium: "info", High: "warning", Critical: "critical" }[p] || "neutral");
export const innStatusBadge = (s) => ({ Idea: "neutral", Researching: "info", Validating: "warning", Planned: "info", "On roadmap": "success", Deferred: "neutral", Rejected: "critical", Delivered: "success" }[s] || "neutral");

// Kanban column accent per status
export const innStatusAccent = (s) => ({
  Idea: "#7C3AED", Researching: "#1D4ED8", Validating: "#E0A82E", Planned: "#06B6D4",
  "On roadmap": "#16A34A", Deferred: "#5A6B8C", Rejected: "#DC2626", Delivered: "#0EA5A4",
}[s] || "#5A6B8C");

export const isReviewOverdue = (i, today) => !!i.next_review_date && i.next_review_date < today && !["Delivered", "Rejected"].includes(i.status);
export const isReviewSoon = (i, today, soon) => !!i.next_review_date && i.next_review_date >= today && i.next_review_date <= soon && !["Delivered", "Rejected"].includes(i.status);

export const innStatusFromSlug = (slug) => {
  if (!slug) return null;
  const found = INN_STATUS.find((s) => s.toLowerCase().replace(/[\s–—]+/g, "-") === slug.toLowerCase());
  return found || null;
};

export const innovationFields = () => [
  { name: "title", label: "Innovation title", type: "text", required: true, placeholder: "e.g. Parent companion app" },
  { name: "problem_opportunity", label: "Problem or opportunity", type: "textarea", placeholder: "What gap or opportunity does this address?" },
  { name: "description", label: "Description", type: "textarea" },
  { name: "user_benefit", label: "User benefit", type: "textarea" },
  { name: "strategic_value", label: "Strategic value", type: "textarea" },
  { name: "estimated_effort", label: "Estimated effort", type: "text", placeholder: "e.g. 6 weeks" },
  { name: "estimated_cost", label: "Estimated cost", type: "text", placeholder: "e.g. £8,000" },
  { name: "priority", label: "Priority", type: "select", options: opt(INN_PRIORITY), required: true },
  { name: "time_horizon", label: "Time horizon", type: "select", options: opt(INN_HORIZON), required: true },
  { name: "dependencies", label: "Dependencies", type: "textarea" },
  { name: "risks", label: "Risks", type: "textarea" },
  { name: "status", label: "Status", type: "select", options: opt(INN_STATUS), required: true },
  { name: "owner", label: "Owner", type: "select", options: opt(INN_OWNERS), required: true },
  { name: "evidence_feedback", label: "Evidence or user feedback", type: "textarea" },
  { name: "next_review_date", label: "Next review date", type: "date" },
  { name: "notes", label: "Notes", type: "textarea" },
];
